<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
        <a class="navbar-brand" href="#">丞毅生活用品</a>
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="nav-item active">
            <a class="nav-link" href="#">產品介紹 <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">最新消息</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">訂購說明</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">關於我們</a>
          </li>
           <li class="nav-item">
            <a class="nav-link" href="#">聯絡我們</a>
          </li>
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
        </form>
      </div>
  </nav> -->

        <header>

            <nav class="nav-shadow navbar navbar-expand-md navbar-dark fixed-top bg-white sidebarNavigation"
                 data-sidebarClass="navbar-dark bg-dark">
                <!-- <a href="index.html"><span>丞毅生活用品</span></a> -->

                <div class="container-fluid  ">

                    <button class="navbar-toggler leftNavbarToggler" @click="burronView=!burronView" >
                        <i class="fas fa-bars" style="color:#4C4C4C; font-size:28px;"></i>
                    </button>

                    <!-- <button class="navbar-toggler leftNavbarToggler" type="button" data-toggle="collapse"
                        data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false"
                        aria-label="Toggle navigation">

                    </button> -->

                    <div class="col top-header" id="navbarCollapse">
                        <ul class="navbar-nav nav-pills nav-fill">

                            <!-- <li class="nav-item dropdown">
                                <a class="h3" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                                   aria-haspopup="true" aria-expanded="false">
                                    產品介紹
                                </a>
                                <div class="dropdown-menu menufont" aria-labelledby="navbarDropdown">
                                  <router-link tag="a" class="dropdown-item" to="/index"><span>流行商品區</span></router-link>
                                  <router-link tag="a" class="dropdown-item" to="/hotIndex"><span>熱門商品區</span></router-link>
                                  <router-link tag="a" class="dropdown-item" to="/preOrder" v-if="user==1 || user==2"><span>預購商品區</span></router-link>
                                </div>
                            </li> -->

                            <!-- <li class="nav-item dropdown" v-if="shopId">
                              <router-link tag="a" class="h3" :to="'/index/'+this.shopId"><span>首頁</span></router-link>
                            </li> -->
                            
                             <li class="nav-item dropdown">
                              <router-link tag="a" class="h3" to="/index" @click.native="refreshCurrent"><span>首頁</span></router-link>
                            </li>

                            <!-- <li class="nav-item dropdown">
                              <router-link tag="a" class="h3" to="/new"><span>最新消息</span></router-link>
                            </li> -->

                            <li class="nav-item dropdown">
                              <router-link tag="a" class="h3" to="/preOrder"  @click.native="refreshCurrent"><span>商品總覽</span></router-link>
                            </li>

                            <!-- <li class="nav-item dropdown">
                              <router-link tag="a" class="h3" to="/aboutUs"><span>關於我們</span></router-link>
                            </li>

                            <li class="nav-item dropdown">
                              <router-link tag="a" class="h3" to="/contactUs"><span>聯絡我們</span></router-link>
                            </li> -->

                        </ul>
                    </div>
                    <ul class="navbar-nav justify-content-end NAV-ICON">
                        <li class="nav-item dropdown" style="margin-right: 25px">
                            <a href="#" id="navbarDropdown5" role="button" data-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false">
                                <img src="../../assets/images/navbar/member.png" width="30" class="img-fluid" alt="member">
                            </a>
                            <div class="dropdown-menu dropdown-menu-right menufont2" aria-labelledby="navbarDropdown5">
                              <template v-if="success">
                                 <li class="login-btn">
                                  <router-link class="dropdown-item" to="/member"><span>會員專區</span></router-link>
                                </li>
                                <li class="register-btn">
                                  <router-link class="dropdown-item" v-on:click.native="logout" to="/login"><span>登出</span></router-link>
                                </li>
                              </template>
                              <template v-else>
                                <li class="login-btn">
                                  <router-link tag="a" class="dropdown-item" to="/login"><span>會員登入</span></router-link>
                                </li>
                                <li class="register-btn">
                                   <router-link tag="a" class="dropdown-item" to="/registered"><span>加入會員</span></router-link>
                                </li>
                              </template>


                            </div>
                        </li>

                        <li class="nav-item dropdown " style="margin-right: 25px">
                            <a href="#" id="navbarDropdown6" role="button" data-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false">
                                <img src="../../assets/images/navbar/chat.png" width="30" class="img-fluid" alt="chat">
                                <i class="fas fa-spinner fa-spin" v-if="status.removeloading"></i>
                                 {{cartsNum}}
                            </a>
                            <div class="dropdown-menu dropdown-menu-right2 menufont2" aria-labelledby="navbarDropdown5">
                                <h6 calss="carttitle">已選擇商品</h6>
                                <hr class="cart-line">
                                <div class="empty" v-if="cartsNum == ''">清單內已無商品</div>
                                <table class="table mt-3 carttable">
                                  <tbody>
                                    <tr v-for="(item,index) in carts" :key="index">
                                      <td>
                                        <button class="btn-outline-danger btn-sm delete-btn" @click="removeCart(item.cartId)">
                                          <i class="fas fa-trash-alt"></i>
                                        </button>
                                      </td>
                                      <td>{{item.name}}</td>

                                      <td>{{item.qty}}</td>
                                      <td class="text-right" v-if="item.subTotal">{{item.subTotal | currency}}</td>
                                      <td class="text-right" v-else>{{item.subTotal2 | currency}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <router-link tag="a" class="dropdown-item" to="/cart"><span>結帳</span></router-link>
                            </div>

                        </li>

                        <!-- <li class="nav-item" style="margin-right: 15px">
                            <a href="#" id="navbarDropdown7" role="button" data-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false">
                                <img src="../../assets/images/navbar/search.png" width="30" class="img-fluid" alt="search">
                            </a>
                            <div class="dropdown-menu dropdown-menu-right3" aria-labelledby="navbarDropdown7">
                                <a href="#" title="Select this card">
                                    <div class="row align-items-center">

                                        <div class="col-6"><input type="text" class="searchinput" placeholder=" 搜尋商品">
                                        </diV>
                                        <div class="col-4"><button class="searchbtn">搜尋</button></diV>
                                    </div>
                                </a>

                            </div>

                        </li> -->
                    </ul>
                </div>
            </nav>

    <div class="cell-index-style ">
         <div class="row justify-content-center ">
              <div class="col-6 nav-style "> 
                 <router-link tag="a" class="h3" to="/index" @click.native="refreshCurrent"><span>首頁</span></router-link>
                </div>
              <div class="col-6 nav-style">  
                <router-link tag="a" class="h3" to="/preOrder"  @click.native="refreshCurrent"><span>商品總覽</span></router-link>
               </div>
            </div>

    </div>
         
            <!-- 手機版側邊欄位 -->
            <nav class="cbp-spmenu cbp-spmenu-vertical nav-mobile" :class="{cbpspmenuleft: this.burronView}">

                 <ul class="list-unstyled components cell-nav-scroll">
                  <li :class="{ 'li_active': active_all}"><a class="arrow" @click="GopreOrder">全部商品</a></li>
                  <li v-for="(item , key) in typeview" :key="item.id" :class="{ 'li_active': active_el ==item.id }"
                    v-show="typedisplay[key]">
                    <span v-if="typedisplay[key]">
                      <a role="button">
                        <span class="arrow" @click="searchType(item.id);activate(item.id)">{{item.type}}</span>
                        <span class="close" :class="{ 'close_active': open[item.id] }" @click="isopen(item.id)"
                          v-if="item.middletypes !=''"></span>
                      </a>
                      <ul class="list" v-if="open[item.id]">
                        <li v-for="item2 in item.middletypes" :key="item2.id"
                          :class="{ 'li_active2': active_el2 ==item2.id }">
                          <a role="button" class="arrow"
                            @click="searchmiddleType(item2.id);activate2(item2.id)">{{item2.middleType}}</a>
                        </li>
                      </ul>
                    </span>
                  </li>
                </ul>
                <!-- <router-link tag="a" to="/index"  @click.native="refreshCurrent"><span>首頁</span></router-link>
                <router-link tag="a" to="/preOrder"  @click.native="refreshCurrent"><span>商品總覽</span></router-link> -->

            </nav>
         

        </header>
  </div>
</template>




<script>
  import axios from "axios";

  export default {
    name: 'Navbar',
    data() {
      return {
        isLoading:false,
        success: '',
        token: '',
        info: '',
        shopId: '',
        now: 1, //現在筆數
        pageSize: 99, //每頁筆數
        carts: {},
        cartsNum:'',
        sum: 0, //總計
        status:{
          removeloading:false//加入局部讀取效果
        },
        user:0,
        burronView:true,//控制手機板側邊欄位滑出滑入
        typeview: "",
        active_all: true, //全部分類
        active_el: "", //第一層
        active_el2: "", //第二層
        typedisplay: [], //判斷依身分登入顯示的分類
        open: [],
        type: '', //搜尋分類
        middleType: '', //搜尋子分類
      }
    },
    methods: {
      refreshCurrent(){
        this.$bus.$emit('Navbar:refreshCurrent');
        this.burronView=true;
      },
         //登出
      logout() {
        const vm = this;
        vm.isLoading = true;
        vm.user="";
        vm.token = window.localStorage.getItem('usertoken');
        const headers = {
          headers: {
            'Authorization': 'Bearer ' + vm.token
          }
        };
        const data = {};
        const me_api = `${process.env.APIPATH}/signout`;
        axios.post(me_api, data, headers)
          .then((res) => {
            vm.isLoading = false;
            localStorage.removeItem('verifiedEmail');
            localStorage.removeItem('usertoken');
          
          
            vm.$bus.$emit('Navbar:getUser');
            vm.$router.push('/login')
            // window.localStorage.clear();//全部移除


          })
          .catch((err) => {
            console.log(err)
          })

      },
      //抓取使用者資料
        getUser() {
        const vm = this;
        vm.isLoading = true;
        vm.token = window.localStorage.getItem('usertoken');
        const headers = {
          headers: {
            'Authorization': 'Bearer ' + vm.token
          }
        };
        const data = {};
        const me_api = `${process.env.APIPATH}/me`;
        axios.post(me_api, data, headers)
          .then((res) => {
            vm.isLoading = false;
            vm.user=res.data.shop;

          })
          .catch((err) => {
            console.log(err)
          })

      },
      ckecklogout() {
        this.token = window.localStorage.getItem('usertoken');
        if (this.token == null) {
          this.success = false

        } else {
          this.success = true
        }
      },
      getCart(start) {
        const vm = this;
        	vm.status.removeloading = true;
        if (!start) start = vm.now;
        const data = {
          shopId: vm.shopId,
          now: start,
          limit: vm.pageSize
        };

        const token = localStorage.getItem("usertoken");
        const headers = {
          headers: {
            Authorization: "Bearer " + token
          }
        };

        const me_api = `${process.env.APIPATH}/getCart`;
        axios
          .post(me_api, data, headers)
          .then(res => {
            vm.status.removeloading = false;
            vm.carts = res.data.data; //購物車內容
            vm.cartsNum=res.data.data.length;
            vm.sum = res.data.sum; //總計


          })
          .catch(err => {
            console.log(err);
          });
      },
      removeCart(id){
      const vm = this;
			vm.status.removeloading = true;

			const data = {
				id: id,
			};

			const token = localStorage.getItem("usertoken");
			const headers = {
				headers: {
					Authorization: "Bearer " + token
				}
			};

			const api = `${process.env.APIPATH}/delCart`;
			axios
				.post(api, data, headers)
				.then(res => {
					const response = res.data;
            vm.status.removeloading = false;
            vm.$bus.$emit('Navbar:updateCart');
					if (response == "okDel") {
           vm.getCart();
					} else if (response == "noToken") {
						alert("請先登入帳號");
						this.$router.push(`/login`);
					}
				})
				.catch(err => {
					console.log(err);
				});
    },
        offEventBus(){//銷毀監聽事件
        this.$bus.$off('Navbar:updateCart');
        this.$bus.$off('Navbar:ckecklogout');
        this.$bus.$off('Navbar:getUser');
     
      },
       getType() {
        let vm = this;
        vm.isLoading = true;
        const data = {
          now: 1,
          limit: 20000
        };

        const me_api = `${process.env.APIPATH}/getAllType`;
        axios
          .post(me_api, data)
          .then(res => {
            vm.isLoading = false;
            vm.typeview = res.data.data;
            var arr = Object.keys(vm.typeview);
            var len = arr.length;
            for (let i = 0; i < len; i++) {
              // vm.open[i] = false;
              
              if(!vm.user)vm.user='0';
              
              if (vm.user == '0') {
               
                if (vm.typeview[i].type == '加盟店專用-開團商品專用區') {
                  vm.typedisplay[i] = false
                } else if (vm.typeview[i].type == '熱門產品現貨區-代理團媽專屬') {
                  vm.typedisplay[i] = false
                } else if (vm.typeview[i].type == '代理專區') {
                  vm.typedisplay[i] = false
                } else {
                  vm.typedisplay[i] = true
                }
              } else if (vm.user == '1') {
                if (vm.typeview[i].type == '代理專區') {
                  vm.typedisplay[i] = false
                } else {
                  vm.typedisplay[i] = true
                }
              } else if (vm.user == '2') {
                vm.typedisplay[i] = true
              }

            }

            //從詳細商品頁面點選分類或是子分類，要跳轉到首頁
            if (vm.type) {
              vm.activate(vm.type);
              vm.searchType(vm.type);
            }
            if (vm.middleType) {
              vm.activate2(vm.middleType);
              vm.searchmiddleType(vm.middleType);
              vm.isopen(vm.selectType);
            }




          })
          .catch(err => {
            console.log(err);
          });
      },
         //第一層分類
      activate(id) {

        this.active_el = parseInt(id);
        this.active_all = false;
        this.active_el2 = "";
      },
      //第二層分類
      activate2(id) {
        this.active_el2 = parseInt(id);
        this.active_all = false;
        this.active_el = "";
      },
        GopreOrder(){
          if(this.$route.path.split('preOrder').length>1){
             localStorage.removeItem("middleType");
              localStorage.removeItem("type");
              this.active_all=true;
              this.type = "";
              this.middleType = "";
              this.active_el = "";
              this.active_el2 = "";
              this.$bus.$emit('Navbar:getbusProduct');
              this.burronView=!this.burronView
          }else {
             this.$router.push('/preOrder');
          }
       
      },
      isopen(key) {
        this.$set(this.open, key, !this.open[key]);
      },
       searchType(id) {
        localStorage.setItem("type", id);
        this.type = localStorage.getItem("type");
        this.middleType = "";
        localStorage.removeItem('middleType'); 
        this.$bus.$emit('Navbar:getbusProduct');
        this.burronView=!this.burronView
      },
      searchmiddleType(id) {
        localStorage.setItem("middleType", id);
        this.middleType = localStorage.getItem("middleType");
        this.type = "";
        localStorage.removeItem('type');
       this.$bus.$emit('Navbar:getbusProduct');
       this.burronView=!this.burronView
      },
    },
    created() {
      const vm = this;
      vm.ckecklogout();
      vm.getUser();
      var t = setTimeout(function () {
           vm.$bus.$emit('Navbar:updateCart');
           vm.getType();
      }, 1000);
       
    },
     mounted(){
    //等舊元件銷毀才註冊
    const vm = this;
    
    vm.$bus.$on('Navbar:updateCart', vm.getCart);
    vm.$bus.$on('Navbar:ckecklogout', vm.ckecklogout);
    vm.$bus.$on('Navbar:getUser', vm.getUser);
  
    vm.$bus.$on('Navbar:shopId',(shopId) => {
        vm.shopId = localStorage.getItem("shopId");
    });
  },
   beforeDestroy(){
    this.offEventBus();
  },

  


  }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Navbar.vue